import { useEffect } from 'react';

import { Info, Settings } from 'lucide-react';

import { Footer } from '@/components/template/Footer';
import { Navbar } from '@/components/template/navbar/Navbar';
import { useAuth } from '@/lib/hooks/useAuth';
import { useSettingsStore } from '@/store';

function MaintenancePage() {
  const { settings } = useSettingsStore();
  const { signOut } = useAuth();

  const pageMode =
    settings.ui?.maintenance?.type === 'page' &&
    settings.ui?.maintenance?.enabled;

  useEffect(() => {
    if (pageMode) {
      signOut();
    }
  }, [pageMode, signOut]);

  return (
    <>
      <Navbar />
      <main className="min-h-screen w-full flex flex-col items-center justify-center bg-gradient-to-br from-background to-muted/50 px-4 py-6 sm:py-12 mt-16">
        {/* Decorative elements */}
        <div className="absolute inset-0 overflow-hidden z-0">
          <div className="absolute -top-20 -left-20 w-64 h-64 bg-primary/5 rounded-full blur-3xl" />
          <div className="absolute top-1/3 -right-20 w-72 h-72 bg-secondary/10 rounded-full blur-3xl" />
          <div className="absolute -bottom-32 left-1/3 w-80 h-80 bg-accent/10 rounded-full blur-3xl" />
        </div>

        <div className="relative z-10 max-w-3xl w-full space-y-12 px-4">
          <div className="mx-auto w-20 h-20 bg-background rounded-full flex items-center justify-center shadow-md">
            <Settings className="h-10 w-10 text-primary animate-spin-slow" />
          </div>

          <div className="space-y-8 text-center">
            <div>
              <h1 className="text-3xl sm:text-4xl font-bold text-foreground tracking-tight">
                We're making things better
              </h1>
              <div className="h-1 w-20 bg-primary mx-auto mt-6 rounded-full"></div>
            </div>

            <p className="text-lg sm:text-xl text-muted-foreground">
              {settings?.ui?.maintenance?.message ||
                'Our system is currently undergoing scheduled maintenance to improve your experience.'}
            </p>

            <div className="bg-muted rounded-lg p-4 flex items-start gap-3 text-left">
              <Info size={20} className="text-primary mt-0.5 flex-shrink-0" />
              <p className="text-sm text-muted-foreground">
                Thank you for your patience as we work to enhance your
                experience. We'll be back shortly.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default MaintenancePage;
